export default __webpack_public_path__ + "static/media/1.81254257.jpg";